/* Levano · wraps neighbouring dark sections in one element so a single gradient
   runs behind both. Pairs are listed by the section-id suffix Shopify gives them. */
(function(){
  var PAIRS=[['__lvf_features','__lvf_specs']];

  function find(suffix){
    var all=document.querySelectorAll('[id^="shopify-section"]');
    for(var i=0;i<all.length;i++){
      if(all[i].id.slice(-suffix.length)===suffix)return all[i];
    }
    return null;
  }

  function group(pair){
    var a=find(pair[0]),b=find(pair[1]);
    if(!a||!b)return;
    if(a.parentNode&&a.parentNode.classList.contains('lvb-pair'))return; /* already grouped */
    if(a.nextElementSibling!==b)return;                                  /* not adjacent: leave alone */
    var wrap=document.createElement('div');
    wrap.className='lvb-pair';
    a.parentNode.insertBefore(wrap,a);
    wrap.appendChild(a);
    wrap.appendChild(b);
  }

  function run(){for(var i=0;i<PAIRS.length;i++)group(PAIRS[i])}

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  /* theme editor re-renders sections: regroup afterwards */
  document.addEventListener('shopify:section:load',run);
  document.addEventListener('shopify:section:reorder',run);
})();
